import { MEMBERSHIPS_STATE } from './memberships-constants'

export const membershipsSelector = state => state[MEMBERSHIPS_STATE]
